interface Props {
  tipo: string;
}
const MensagemSincronizacao: React.FC<Props> = ({ tipo }: Props): React.ReactElement => {
  if (tipo === 'ER') {
    return <span className="badge bg-danger">Erro</span>;
  }
  if (tipo === 'VE') {
    return <span className="badge bg-warning">Validação CNMP</span>;
  }
  if (tipo === 'VI') {
    return <span className="badge bg-warning">Validação MPPB</span>;
  }
  return <span className="badge">Desconhecido</span>;
};
interface Props {
  tipo: string;
}

export default MensagemSincronizacao;
